export default {}



// WEBPACK FOOTER //
// ./.nuxt/middleware.js